<template>
  <div class="main">
    <div class="form-container">
      <div class="login-text">Bentornato!</div>
      <div class="login">
        <div>
          <Button class="google-button" @click="GoogleLogin">
            <span>Accedi con Google</span>
            <span>
              <GoogleIcon class="google-icon" />
            </span>
          </Button>
        </div>
        <div class="email-login">
          <span class="divider">
            <span class="line"></span>
            <span class="text">Oppure accedi con la tua mail</span>
            <span class="line"></span>
          </span>
          <input class="form-elements" type="text" id="Mail" v-model="Mail" placeholder="Inserisci la tua mail"
            required />
          <input class="form-elements" type="password" id="Password" v-model="Password"
            placeholder="Inserisci la password" required />
          <p v-if="errMsg" class="error-message">{{ errMsg }}</p>
          <div class="sub-section">
            <label for="remember-me" class="checkbox-label">
              <input type="checkbox" id="remember-me" class="box-tick">
              <span>Ricordati di me</span>
            </label>
            <div class="forgot">Password dimenticata</div>
          </div>
          <Button class="login-button" @click="signin">
            Accedi
          </Button>
        </div>
        <div class="subscribe">
          Non hai ancora un account? <router-link class="link-sub" to="/signup">Iscriviti!</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleIcon from '@/assets/Icons/SocialMedia/Google.vue';
import { useAuthStore } from '@/stores/authStore';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export default {
  name: 'MainLogIn',
  components: {
    GoogleIcon,
  },
  setup() {
    const Mail = ref('');
    const Password = ref('');
    const router = useRouter();
    const auth = useAuthStore();

    const signin = async () => {
      await auth.login(Mail.value, Password.value);
      if (!auth.error) {
        console.log("Utente acceduto con successo!");
        router.push('/');
      } else {
        console.log(auth.error);
        alert(auth.error);
      }
    };

    const GoogleLogin = async () => {
      await auth.googleLogin();
      if (!auth.error) {
        console.log("Utente acceduto con successo con Google!");
        router.push('/');
      } else {
        console.log(auth.error);
        alert(auth.error);
      }
    };

    return {
      Mail,
      Password,
      signin,
      GoogleLogin,
      auth,
    };
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #ffffff, #56BCEE);
  justify-content: center;
  align-items: center;
}

.form-container {
  background: rgba(255, 255, 255, 0.95);
  padding: 3rem;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.login-text {
  font-size: 2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 2rem;
  text-align: center;
}

.login {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.google-button {
  width: 100%;
  padding: 1rem;
  background: #ffffff;
  border: 2px solid #e0e0e0;
  border-radius: 0;
  font-size: 1rem;
  font-weight: 500;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  gap: 1rem;

  &:hover {
    background: #f8f8f8;
  }
}

.google-icon {
  width: 24px;
  height: 24px;
}

.divider {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #666;
  font-size: 0.9rem;
  margin: 1.5rem 0;

  .line {
    flex: 1;
    height: 1px;
    background: #e0e0e0;
  }
}

.form-elements {
  width: 100%;
  padding: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 0;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    border-color: #2e4eed;
    outline: none;
  }

  &::placeholder {
    color: #999;
  }
}

.error-message {
  color: #dc2626;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}

.sub-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem 0;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #666;
  cursor: pointer;

  .box-tick {
    width: 16px;
    height: 16px;
    accent-color: #2e4eed;
  }
}

.forgot {
  font-size: 0.9rem;
  color: #2e4eed;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.login-button {
  width: 100%;
  padding: 1rem;
  background: #2e4eed;
  color: #ffffff;
  border: none;
  border-radius: 0;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #1e3ed8;
  }
}

.subscribe {
  font-size: 0.9rem;
  color: #666;
  text-align: center;

  .link-sub {
    color: #2e4eed;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .form-container {
    padding: 2rem;
    margin: 1rem;
  }

  .login-text {
    font-size: 1.75rem;
  }
}
</style>